module.exports = __webpack_public_path__ + "assets/img/d2b7d2e796ddba1a260e733b28e344a4.svg";